module.exports = __webpack_public_path__ + "img/horizontal_5_1_3009.40d46898.png";